import { channels } from '../../../test.data';
import Card from '../../cards/card';
import HeaderInfoCard from '../../cards/v2/info-card/header.info-card';
import { styles } from '../../cards/v2/info-card/styles';

type Props = {
  id: string;
  close: Function;
};

export default function MediaView({ id, close }: Props) {
  const channel = channels.find((c) => c.id === id);

  return (
    <Card className={styles.container}>
      <Card.Header className={styles.header}>
        {channel && (
          <HeaderInfoCard
            buttonIcon="back"
            title={'Media and links'}
            close={close}
          />
        )}
      </Card.Header>
      <Card.Body className={styles['alt-body']}>
        <div className="px-5 pt-3">Media</div>
      </Card.Body>
    </Card>
  );
}
